// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.picker {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  padding: 16px;
  gap: 12px;
}

.picker-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.picker-title {
  margin: 0;
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 18px;
}

.picker-file {
  margin: 0;
  font-size: 13px;
  color: #8c8f93;
}

.picker-file-name {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
  white-space: nowrap;
  color: #0b2d71;
}

.picker-search-input {
  box-sizing: border-box;
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 13px;
}
.picker-search-input:focus {
  outline: none;
  border-color: #0066b2;
}

.picker-body {
  flex: 1 1 auto;
  min-height: 120px;
  overflow-y: auto;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
}

.picker-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 12px;
  border-bottom: 1px solid #e3e3e3;
  cursor: pointer;
}
.picker-row:hover, .picker-row:focus-within {
  background-color: #e4f4fa;
}
.picker-row--selected {
  background-color: rgba(0, 102, 178, 0.06);
}

.picker-row-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.picker-row-title {
  font-size: 13px;
  color: #0b2d71;
}

.picker-row-detail {
  font-size: 12px;
  color: #8c8f93;
}

.picker-empty,
.picker-more {
  margin: 0;
  padding: 12px;
  font-size: 13px;
  color: #8c8f93;
}

.picker-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.picker-footer-spacer {
  flex: 1 1 auto;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
